var ReactTooltip = require("react-tooltip");

var Glyphicon = require("components/utility/icons/Glyphicon");
var BookAnswersAnalysisTable = require("components/data/subjects/shared/BookAnswersAnalysisTable");
var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");

require("data/data_table");

class DataTable extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = {
      expandedRows: []
    }
  }

  colorClasses(value) {
    // if value is not a string, return black
    if (!(typeof value == 'string')) {
      return { backgroundClass: 'backgroundColor-black', fontClass: 'fontColor-black' }
    }

    if (_.includes(AutograderDisplayConfig.SUCCESS_OUTPUT, $wr.toTitleCase(value))) {
      var backgroundClass = 'backgroundColor-green'
      var fontClass = 'fontColor-green'
    } else if (_.includes(AutograderDisplayConfig.FAIL_OUTPUT, $wr.toTitleCase(value))) {
      var backgroundClass = 'backgroundColor-red'
      var fontClass = 'fontColor-red'
    } else if (_.includes(AutograderDisplayConfig.MIDDLING_OUTPUT, $wr.toTitleCase(value))) {
      var backgroundClass = 'backgroundColor-yellow'
      var fontClass = 'fontColor-yellow'
    }

    return { backgroundClass, fontClass}
  }

  renderEmptyColumn() {
    return (
      <div className='emptyColumn'>
        <Glyphicon icon="minus" className="minusSign" />
      </div>
    )
  }

  buildBookAnswersAnalysisTable() {
    var tableHash = this.state.bookAnswersAnalysisTable
    if (tableHash.show) {
      var { textID, userID } = tableHash
      return <BookAnswersAnalysisTable textID={textID} userID={userID} />
    }
  }

  buildAvatarColumn(cell) {
    return (
      <div className='avatarCell'>
        <div className='col-left'>
          {cell.avatar}
        </div>
        <div className='col-middle'></div>
        <div className='col-right'>
          {cell.value}
        </div>
      </div>
    )
  }

  buildRubricColumn(cell) {    
    var rubricItems = _.map(cell.value, (label, key) => {
      if (label) {
        var { fontClass } = this.colorClasses(label)
        var output = $wr.toTitleCase(label)
        if (output in OUTPUT_ABBREV) {
          output = OUTPUT_ABBREV[output]
        }
        return (
          <span key={key} className='rubricItemContainer'>
            <div className='rubricItem'>{RUBRIC_ITEM_NAMES[key]}:</div>
            <div className={`rubricItemValue ${fontClass}`}>{output}</div>
          </span>
        )
      }
    })

    return (
      <span>
        {rubricItems}
      </span>
    )
  }
  
  buildReadBookColumn(cell) {
    var { backgroundClass, fontClass } = this.colorClasses(cell.value)
    return (
      <div className={`readBookCell ${backgroundClass}`}>
        <div className={`readBookCellValue ${fontClass}`}>{$wr.toTitleCase(cell.value)}</div>
      </div>
    )
  }

  toggleExpandedContent(cell) {
    if (cell.book_answers_analysis) {
      var { userID, textID } = cell.book_answers_analysis
      this.setState({
        bookAnswersAnalysisTable: {
          show: !this.state.bookAnswersAnalysisTable.show,
          userID,
          textID
        }
      })
    }
  }

  expandContent(rowIndex) {
    if (_.includes(this.state.expandedRows, rowIndex)) {
      this.setState({ expandedRows: [..._.omit(this.state.expandedRows, rowIndex)]})
    } else {
      this.setState({ expandedRows: [...this.state.expandedRows, rowIndex] })
    }
  }

  buildShowMoreLink(rowIndex) {
    return <div onClick={() => this.expandContent(rowIndex)} className="showMoreText">Show More</div>
  }

  renderToolTip(confidence) {
    var dataTip = `${confidence}% Confidence`
    return (
      <div className='infoTooltip'>
        <Glyphicon icon="info-sign" className="infoSign" dataTip={dataTip} />
        <ReactTooltip effect="solid" />
      </div>
    )
  }

  // needs to be handled differently
  buildBookAnswerAnalysisColumn(cell, rowIndex) {
    var { backgroundClass, fontClass } = this.colorClasses(cell.value)

    if (cell.confidence) {
      var confidenceValue = Math.round(cell.confidence * 100)
      var confidence = <div className={`confidenceValue ${fontClass}`}>{confidenceValue}%</div>
      var showMore = this.buildShowMoreLink(rowIndex)
      var toolTip = this.renderToolTip(confidenceValue)
    }

    // could render a string or a link
    var cellValue = typeof cell.value == 'string' ? $wr.toTitleCase(cell.value) : cell.value

    return (
      <div className='detailedReadBookColumn'>
        <div className={`readBookCell ${backgroundClass}`}>
          <div className={`readBookCellValue ${fontClass}`}>{cellValue}</div>
        </div>
        {confidence}
        {toolTip}
        {/* {showMore} */}
      </div>
    )
  }

  generateExpandedContent(row, index) {
    if (this.props.subjectType) {
      switch (this.props.subjectType) {
        // for the books table, expanded content will be book answers analysis table
        case BOOKS:
          var bookAnswersAnalysisColumn = _.findWhere(row, { book_answers_analysis_column: true })
          var { component_props } = bookAnswersAnalysisColumn.expanded_content
          
          var expandedClass = _.includes(this.state.expandedRows, index) ? 'expanded' : ''
          return (
            <tr className={`bookAnswersAnalysisTableRow ${expandedClass}`}>
              <td className='tableContiner' colSpan={_.size(this.props.columnHeaders)}>
                <BookAnswersAnalysisTable {...component_props} />
              </td>
            </tr>
          )
      }
    }
  }

  generateColumns(row, rowIndex) {
    var columns = _.map(row, (cell, index) => {
      var cellContent = cell.value

      if (_.isEmpty(cell.value) || !cell.value) {
        cellContent = this.renderEmptyColumn()
      } else {
        if (cell.avatar) {
          cellContent = this.buildAvatarColumn(cell)
        }

        if (cell.link) {
          cellContent = <a href={cell.link}>{cell.value}</a>
        }

        if (cell.read_book_column) {
          cellContent = this.buildReadBookColumn(cell)
        }

        if (cell.rubric_column) {
          cellContent = this.buildRubricColumn(cell)
        }

        if (cell.book_answers_analysis_column) {
          cellContent = this.buildBookAnswerAnalysisColumn(cell, rowIndex)
        }
      }

      return (
        <td key={index} colSpan={1} className={`cell ${cell.classes.join(' ')}`}>
          {cellContent}
        </td>
      )
    })

    return (
      <tr>
        {columns}
      </tr>
    )
  }
  generateRows() {
    return _.map(this.props.rows, (row, index) => {
      return (
        <tbody key={index} className='tbodyRow'>
          {this.generateColumns(row, index)}
          {this.generateExpandedContent(row, index)}
        </tbody>
      )
    })
  }
  generateHeaders() {
    return _.map(this.props.columnHeaders, header => {
      if (_.includes(_.keys(HEADER_TOOLTIPS), header)) {
        var dataTip = HEADER_TOOLTIPS[header]
        return (
          <th key={header} className={`columnHeader`} data-tip={dataTip} data-for="columnDataTip">
            {header}
            <ReactTooltip effect="solid" id='columnDataTip' />
          </th>
        )
      } else {
        return <th key={header} className={`columnHeader`}>{header}</th>
      }
    })
  }

  render() {
    var { printable, subjectType } = this.props
    
    return (
      <div className={`dataTable ${printable ? 'showOnPrint' : 'hideOnPrint'} ${subjectType}Table`} >
        <table className="table">
          <thead>
            <tr>
              {this.generateHeaders()}
            </tr>
          </thead>
          {this.generateRows()}
        </table>
      </div>
    );
  }
};

var BOOK_ANSWERS_ANALYSIS = 'BookAnswersAnalysis'
var BOOKS = 'books'

var HEADER_TOOLTIPS = {
  'Rubric': 'Includes evaluations from all quiz and practice question answers completed for a specific book.',
  'Read Book': 'Whether the entirety of the student\'s work provides enough text evidence to prove that the student read the book.'
}

var OUTPUT_ABBREV = {
  'Sufficient': 'Suf',
  'Insufficient': 'Insuf'
}

var RUBRIC_ITEM_NAMES = {
  "fully_answered": 'Full Answered',
  "restated": "Restating",
  "text_evidence": "Text Evidence",
}

DataTable.propTypes = StrictPropTypes({
  rows: PropTypes.array,
  columnHeaders: PropTypes.array,
  subjectType: PropTypes.string,
  printable: PropTypes.bool,
});

module.exports = DataTable;



// WEBPACK FOOTER //
// ./modules/components/data/subjects/shared/DataTable.js